/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2023 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { settings } from "@/libraries/storage";
import { AccessLogin } from "@/interfaces/GlobalsInterface";
import { assign } from "lodash";
import { Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({
    name: 'AclStore',
    namespaced: true,
})
export default class AclStore extends VuexModule {
    userData: Readonly<AccessLogin> | null = settings.get('auth', 'user', 'data', null)

    @Mutation
    setUserData(userData: AccessLogin | null): void {
        settings.set('auth', 'user', 'data', userData)

        this.userData = userData
    }

    @Mutation
    updUserData(userData: Partial<AccessLogin>): void {
        userData = assign(this.userData, userData)

        settings.set('auth', 'user', 'data', userData)

        this.userData = userData as AccessLogin
    }
}
